import { attr, css, FASTElement, html } from '@microsoft/fast-element';
import { NatGenDesignSystem } from '../../natgen-design-system';
import { display } from '../../foundation/display';

/**
 * @element natgen-heading
 */
export class NatGenHeading extends FASTElement {
    @attr
    level: string;
    levelChanged() {
        this.ariaLevel = this.level;
    }

    computeHeadingLevel(): number {
        let level = 1, currentParent = this.parentElement?.parentElement;

        while (currentParent && currentParent != this.getRootNode() && level < 5) {
            for (let i = 0; i < currentParent.childNodes.length; i++) {
                const node = currentParent.childNodes[i];

                if (node === this)
                    continue;

                if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName.toLowerCase() === 'natgen-heading') {
                    level++;
                    break;
                }
            }

            currentParent = currentParent.parentElement;
        }

        return level;
    }

    @attr
    size: string;
    sizeChanged() {
        this.updateSize();
    }

    updateSize() {
        // TODO: Should this map be configurable through tokens?
        const computedSize = this.size || ['heading', 'heading-small', 'body-x-large', 'body-large', 'body'][parseInt(this.ariaLevel) - 1];
        this.style.setProperty('--font-size', `var(--typography-${computedSize}-font-size)`);
        this.style.setProperty('--line-height', `var(--typography-${computedSize}-line-height)`);
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.ariaLevel = this.level || this.computeHeadingLevel().toString();
        this.updateSize();
    }
}

export const natGenHeadingDefinition = NatGenHeading.compose({
    name: `${NatGenDesignSystem.prefix}-heading`,
    template: html`
        <template role="heading">
            <slot></slot>
        </template>
    `,
    styles: css`
        ${display('block')}

        :host {
            font-size: var(--font-size);
            line-height: var(--line-height);
            font-weight: 700;
        }
    `
});
